import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'rectangle', 'Rectangle', [["path",{"d":"M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10","key":"svg-0"}]]);